import React from 'react'
import PropTypes from 'prop-types';
import Section from '../components/Section';
import {withRouter} from "react-router";
import Tr from "translations/Translations";
import Offers from "components/complex/offer/Offers";


function OfferSection(
    {

        match,

    }) {


    return (
        <div id="offersSection">
            <Section
                title={Tr('offers')}
            >
                <Offers demandId={match.params.id}/>
            </Section>
        </div>
    )
}

OfferSection.propTypes = {
    classes: PropTypes.any,
}

export default withRouter(OfferSection);